import React, { useMemo } from "react";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { graphql, useLazyLoadQuery } from "react-relay";
import { ArchivedTeamsQuery } from "./__generated__/ArchivedTeamsQuery.graphql";
import { FlatList } from "react-native";
import { AHSeparator, ListItem, useBoxStyle } from "arkh";
import { TeamIconCircle } from "../../components/mobile/TeamIconCircle";
import { StoreAdminNavigationScreenProps } from "./StoreAdminNavigation";

export function ArchivedTeams(
  props: StoreAdminNavigationScreenProps<"ArchivedTeams">
) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => <InnerArchivedTeams {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerArchivedTeams(
  props: StoreAdminNavigationScreenProps<"ArchivedTeams"> & {
    fetchKey: string;
  }
) {
  const data = useLazyLoadQuery<ArchivedTeamsQuery>(
    graphql`
      query ArchivedTeamsQuery {
        store {
          allTeams(includeArchived: true) {
            id
            isArchived
            name
            ...TeamIconCircleComponent_Team
          }
        }
      }
    `,
    {},
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  const archivedTeams = useMemo(
    () => data.store.allTeams.filter((team) => team.isArchived),
    [data.store.allTeams]
  );

  const contentContainerStyle = useBoxStyle({
    space: "medium",
  });

  return (
    <FlatList
      contentContainerStyle={contentContainerStyle}
      data={archivedTeams}
      keyExtractor={(item) => item.id}
      ItemSeparatorComponent={AHSeparator}
      renderItem={({ item, index }) => (
        <ListItem
          isFirst={index === 0}
          isLast={index === archivedTeams.length - 1}
          onPress={() => {
            props.navigation.navigateDeprecated("TeamAdmin", {
              teamId: item.id,
            });
          }}
          left={<TeamIconCircle size="smallMedium" team={item} />}
          right={<ListItem.NavArrow />}
        >
          <ListItem.Title>{item.name}</ListItem.Title>
        </ListItem>
      )}
    />
  );
}
